import { strategyToOptions } from "@/common/utils/strategyToOptions"

export const companyStatus: Record<string, string> = {
  active: 'Ativo',
  blocked: 'Bloqueado',
  disabled: 'Inativo',
}

export const companyStatusOptions = strategyToOptions(companyStatus);
